// extracted by mini-css-extract-plugin
module.exports = {"NoData":"Chart_NoData__2Rm1d","LoadingText":"Chart_LoadingText__3P-55"};